import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var ListItemWireframe = function (_a) {
    var className = _a.className, animate = _a.animate;
    return (React.createElement("svg", { className: cn(styles.wireframe, animate && styles.wireframeAnimate, className), viewBox: "0 0 740 104", xmlns: "http://www.w3.org/2000/svg", version: "1.1" },
        React.createElement("rect", { className: styles.shape, x: "0", y: "0", width: "520", height: "8" }),
        React.createElement("rect", { className: styles.shape, x: "0", y: "20", width: "520", height: "8" }),
        React.createElement("rect", { className: styles.shape, x: "0", y: "40", width: "340", height: "8" }),
        React.createElement("rect", { className: styles.shape, x: "570", y: "0", width: "170", height: "104" })));
};
export default ListItemWireframe;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/listItemWireframe/index.tsx
// module id = RkVG
// module chunks = 2